import React from 'react';
// import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Navbar, Nav } from 'react-bootstrap';
import { navigationActions } from '../actions/navigationActions';
import { useNavigation } from './NavigationProvider';
import './component.css';
// import { useInternationalization } from '../hooks/useInternationalization';
// import { LANGUAGES } from '../translations/languages';
import { useIntl } from 'react-intl';
import campusLogo from '../assets/images/campus_logo.png';
// import itaFlag from '../assets/images/ita-flag.png';
// import esFlag from '../assets/images/es-flag.png';
// import frFlag from '../assets/images/fr-flag.png';
// import ukFlag from '../assets/images/uk-flag.png';
// import deFlag from '../assets/images/de-flag.png';
import styles from './Navbar.module.css';
import useWindowSize from '../hooks/useWindowSize';

export const NavBarHospital = ({ history }) => {
    const [locationState, dispatch] = useNavigation();

    // const { changeLocale, locale } = useInternationalization();

    const windowSize = useWindowSize();
    const windowSizesLarge = ['md', 'lg'];

    const intl = useIntl();
    const { formatMessage } = intl;

    const handleLogoClick = () => {
        if (locationState.route !== "/") {
            history.push("/");
            navigationActions.changeNavigation("/", dispatch);
        }
    };

    const getNavLinkBaseProps = path => {
        return {
            style: {
                textTransform: 'uppercase',
                fontSize: '0.5em',
                color: '#fff',
                ...(
                    (locationState.route === path) ?
                        {
                            fontWeight: "bold",
                            textDecoration: 'underline',
                        } :
                        {}
                )
            },
            onClick: () => {
                history.push(path);
                navigationActions.changeNavigation(path, dispatch);
            },
        };
    };

    const renderNavbarCollapse = () => {
        return (
            <Navbar.Collapse
                id="responsive-navbar-nav"
                className="justify-content-end mr-0"
            >
                <Nav
                    className={`align-items-start align-items-md-center`}
                    style={{ cursor: "pointer" }}
                >
                    <Nav.Link
                        {...getNavLinkBaseProps('/status')}
                        eventKey={1}
                    >
                        {formatMessage({ id: 'homePage.statusProntoSoccorso' })}
                    </Nav.Link>
                    <Nav.Link
                        {...getNavLinkBaseProps('/monitoraggio')}
                        eventKey={2}
                    >
                        {formatMessage({ id: 'homePage.monitoraggioPaziente' })}
                    </Nav.Link>
                    <Nav.Link
                        {...getNavLinkBaseProps('/chisiamo')}
                        eventKey={3}
                    >
                        {formatMessage({ id: 'navbar.chisiamo' })}
                    </Nav.Link>
                    <Nav.Link
                        {...getNavLinkBaseProps('/faq')}
                        eventKey={4}
                    >
                        {formatMessage({ id: 'navbar.faq' })}
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
        );
    };

    return (
        <>
            <Navbar
                collapseOnSelect
                expand="md"
                variant="dark"
                className="justify-content-start px-2 py-1 px-md-3 py-md-2"
                style={{
                    zIndex: 1000,
                    background: "rgba(180, 17, 26, 0.75)",
                }}
            >
                <div className="d-flex align-items-center w-100">
                    <Navbar.Toggle
                        aria-controls="responsive-navbar-nav align-self-center"
                        className={`mr-3 border-0 text-white ${styles.navbarBrandToggle}`}
                    />
                    <Navbar.Brand
                        style={{ cursor: locationState.route !== "/" ? "pointer" : "unset" }}
                        onClick={handleLogoClick}
                        className="mr-0"
                    >
                        <div className="container-fluid p-0" style={{ justifyContent: "flex-start" }}>
                            <img
                                alt="campus-logo"
                                src={campusLogo}
                                width="7%"
                                height="3%"
                                className="d-inline-block align-top mr-3 rounded-circle justify-content-start"
                            />
                            <div
                                className={`d-flex flex-column flex-md-row ${styles.navbarBrandTitle}`}
                            >
                                <span>
                                    {formatMessage({ id: "navbar.policlinicoTitolo" })}
                                    <span>&nbsp;</span>
                                </span>
                                <span className="font-weight-bold">
                                    {formatMessage({ id: "navbar.campusTitolo" })}
                                </span>
                            </div>
                        </div>
                    </Navbar.Brand>
                    {/** Navbar collapse desktop */}
                    {
                        windowSizesLarge.indexOf(windowSize) > -1 ?
                            renderNavbarCollapse() :
                            null
                    }
                    {/*                     <NavDropdown
                        className={`rounded-0 font-weight-bold text-white text-right ml-auto ${styles.languageDropdown}`}
                        alignRight
                        title={locale.toUpperCase()}
                        id="basic-nav-dropdown"
                    >
                        <NavDropdown.Item onClick={() => changeLocale(LANGUAGES.IT)}>
                            <img
                                alt="ita-flag"
                                src={itaFlag}
                                className="d-inline-block mr-2"
                                width="24"
                            />
                            <span className={styles.languageDropdownOption}>Italiano</span>
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => changeLocale(LANGUAGES.EN)}>
                            <img
                                alt="uk-flag"
                                src={ukFlag}
                                className="d-inline-block mr-2"
                                width="24"
                            />
                            <span className={styles.languageDropdownOption}>English</span>
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => changeLocale(LANGUAGES.FR)}>
                            <img
                                alt="fr-flag"
                                src={frFlag}
                                className="d-inline-block mr-2"
                                width="24"
                            />
                            <span className={styles.languageDropdownOption}>Français</span>
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => changeLocale(LANGUAGES.DE)}>
                            <img
                                alt="de-flag"
                                src={deFlag}
                                className="d-inline-block mr-2"
                                width="24"
                            />
                            <span className={styles.languageDropdownOption}>Deutsch</span>
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => changeLocale(LANGUAGES.ES)}>
                            <img
                                alt="es-flag"
                                src={esFlag}
                                className="d-inline-block mr-2"
                                width="24"
                            />
                            <span className={styles.languageDropdownOption}>Español</span>
                        </NavDropdown.Item>
                    </NavDropdown> */}
                </div>
                {/** Navbar collapse mobile */}
                {
                    windowSizesLarge.indexOf(windowSize) === -1 ?
                        renderNavbarCollapse() :
                        null
                }
            </Navbar>
        </>
    );
}